import { render, staticRenderFns } from "./RoomMovementReport.vue?vue&type=template&id=ff27dd98"
import script from "./RoomMovementReport.vue?vue&type=script&lang=js"
export * from "./RoomMovementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports